import React from 'react';
import withStyles from "../wrappers/withStyles";

function Dashboard({ color }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <g fill={color} fillRule="nonzero" stroke="none" strokeWidth="1">
        <path
          d="M71.527 13.307H8.317C3.733 13.307 0 17.04 0 21.624V58.22c0 4.584 3.733 8.317 8.317 8.317h63.21c4.584 0 8.317-3.733 8.317-8.317V21.624c0-4.584-3.733-8.317-8.317-8.317zm4.99 44.913a4.996 4.996 0 01-4.99 4.99H8.317a4.996 4.996 0 01-4.99-4.99V21.624a4.996 4.996 0 014.99-4.99h63.21a4.996 4.996 0 014.99 4.99V58.22z"
          transform="translate(10 10.078)"
        />
        <path
          d="M78.18 23.288H1.664C.745 23.288 0 24.033 0 24.95v9.98c0 .919.745 1.664 1.663 1.664h76.518c.918 0 1.663-.745 1.663-1.663v-9.98c0-.919-.745-1.664-1.663-1.664zm-1.663 9.98H3.327v-6.653h73.19v6.653zM31.605 46.576H11.644a1.664 1.664 0 000 3.327h19.961a1.664 1.664 0 000-3.327zM31.605 53.23H11.644a1.664 1.664 0 000 3.326h19.961a1.664 1.664 0 000-3.327zM64.873 43.249h-3.326a4.996 4.996 0 00-4.99 4.99v3.327a4.996 4.996 0 004.99 4.99h3.326a4.996 4.996 0 004.99-4.99v-3.327a4.996 4.996 0 00-4.99-4.99zm1.664 8.317c0 .918-.745 1.663-1.664 1.663h-3.326a1.664 1.664 0 01-1.664-1.663v-3.327c0-.918.745-1.663 1.664-1.663h3.326c.919 0 1.664.745 1.664 1.663v3.327z"
          transform="translate(10 10.078)"
        />
      </g>
    </svg>
  );
}

Dashboard.defaultProps = {
  color: 'white',
};

export default withStyles(Dashboard);
